import React from 'react';
import TimelineGeneric from '../TimelineGeneric';
import { useTranslation } from 'Components/Helpers/translate';
import type { TimelineCardComponent } from '../TimelineGeneric/TimelineCardConfigs';

const TimelineCardCreditMonitoring = (({ event, ...passthrough }) => {
	const { t } = useTranslation();

	let value;
	if (event.value) {
		value = JSON.parse(event.value);
	}

	switch (event.subType) {
		case 'Added':
			return (
				<TimelineGeneric
					event={event}
					titleElements={[() => t('event.creditMonitoring.added')]}
					{...passthrough}
				/>
			);
		case 'Removed':
			return (
				<TimelineGeneric
					event={event}
					titleElements={[() => t('event.creditMonitoring.removed')]}
					{...passthrough}
				/>
			);
		case 'RatingChanged': {
			const oldRating = value.oldRating;
			const newRating = value.newRating;
			const oldNumericRating = value.oldNumericRating;
			const newNumericRating = value.newNumericRating;

			const ratingIncreased = oldRating > newRating || oldNumericRating < newNumericRating;
			const ratingDecreased = oldRating < newRating || oldNumericRating > newNumericRating;
			const ratingAdded = !oldRating && newRating;

			let text = '';
			if (ratingAdded) {
				text =
					t('event.creditMonitoring.creditRating') +
					` ${newRating}${newNumericRating ? ` ${newNumericRating}` : ''}`;
			} else if (ratingIncreased) {
				text = t('event.creditMonitoring.creditRatingIncreased', {
					from: `${oldRating}${oldNumericRating ? ` ${oldNumericRating}` : ''}`,
					to: `${newRating}${newNumericRating ? ` ${newNumericRating}` : ''}`
				});
			} else if (ratingDecreased) {
				text = t('event.creditMonitoring.creditRatingDecreased', {
					from: `${oldRating}${oldNumericRating ? ` ${oldNumericRating}` : ''}`,
					to: `${newRating}${newNumericRating ? ` ${newNumericRating}` : ''}`
				});
			}

			return <TimelineGeneric titleElements={[() => text]} event={event} {...passthrough} />;
		}
		default:
			return null;
	}
}) satisfies TimelineCardComponent;

export default TimelineCardCreditMonitoring;
